import React, { useState } from 'react';
import styled from 'styled-components';
import { Color, Grid, Type } from '../../../app/StyleGuide';
import { LikertScale } from '../models/assessment';

const ScaleList = styled.ul`
  margin: ${Grid._6} auto;
  padding: 0;
  li {
    list-style: none;
    display: flex;
    cursor: pointer;
    border-top: 1px solid ${Color.Gray._30};
    margin: 0;
    color: ${Type.Color.medium};
    font-size: ${Type.Scale._3};
    &:last-child {
      border-bottom: 1px solid ${Color.Gray._30};
    }
    &.selected,
    &:hover {
      background: ${Color.Gray._10};
    }
    .choice-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      background: ${Color.Secondary._80};
      min-width: 60px;
      i {
        font-size: 26px;
      }
    }
    .choice-text {
      display: flex;
      flex: 1;
      align-items: stretch;
      padding: 16px;
    }
  }
`;

type LikertQuestionProps = {
  likertScale: LikertScale;
  setCurrentQuestionAnswer: (score: number) => void;
};

export default function LikertQuestion({ likertScale, setCurrentQuestionAnswer }: LikertQuestionProps) {
  const [selectedScore, setSelectedScore] = useState<number | null>(null);

  const handleSelect = (score: number) => {
    setSelectedScore(score);
    setCurrentQuestionAnswer(score);
  };

  return (
    <ScaleList>
      {likertScale.options.map(option => {
        const isSelected = selectedScore === option.score;
        return (
          <li
            key={`likert-${option.score}`}
            onClick={() => handleSelect(option.score)}
            className={isSelected ? 'selected' : ''}
          >
            <span className="choice-icon">
              <i className={isSelected ? 'icon ion-ios-circle-filled' : 'icon ion-ios-circle-outline'} />
            </span>
            <span className="choice-text">{option.label}</span>
          </li>
        );
      })}
    </ScaleList>
  );
}
